import { useContext, useState } from 'react';

import { Tabs } from 'antd';
import { PermissionContext } from 'components/Global/AuthLayout';
import PaymentComponent from '../Payments';
import styles from './index.module.scss';
import './index.scss';
import PayrollHistory from './PayrollHistory';
import PayrollOverview from './PayrollOverview';

const PayrollComponent = () => {
	const [activeKey, setActiveKey] = useState('payrollOverview');
	const changeTab = (key: any) => {
		setActiveKey(key);
	};
	const context = useContext(PermissionContext);

	let tabItems = [
		{
			key: 'payrollOverview',
			label: 'Payroll Overview',
			children: <PayrollOverview />,
		},
		{
			key: 'payrollHistory',
			label: 'Payroll History',
			children: <PayrollHistory />,
		},
	];

	if (context.isAdmin) {
		tabItems.push({
			key: 'paymentLogs',
			label: 'Payment Logs',
			children: <PaymentComponent />,
		});
	}
	return (
		<div
			className={`payroll-component ${styles['payroll-components']}`}
		>
			<p>Payroll</p>

			<div className={styles['payroll-components__table']}>
				<Tabs
					defaultActiveKey={activeKey}
					activeKey={activeKey}
					items={tabItems}
					destroyInactiveTabPane={true}
					onChange={(key) => changeTab(key)}
					style={{
						fontSize: '18px',
						marginBottom: '40px',
					}}
				/>
			</div>
		</div>
	);
};

export default PayrollComponent;
